<template>
  <svg viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_48352_215805)">
      <path d="M73.7005 65.9659V38.6174C73.7005 36.015 71.5713 33.8858 68.9689 33.8858H50.2319C48.8597 33.8858 47.5349 33.2707 46.6359 32.2297L44.554 29.7693C43.655 28.7284 42.3302 28.1133 40.958 28.1133H31.1163C28.514 28.1133 26.3848 30.2425 26.3848 32.8449V65.9659C26.3848 68.5682 28.514 70.6975 31.1163 70.6975H68.9689C71.5713 70.6975 73.7005 68.5682 73.7005 65.9659Z" stroke="currentColor" stroke-width="5.57143" />
      <path d="M70.8623 44.3086H40.5802C38.4983 44.3086 36.7949 46.2012 36.7949 48.5197V72.698M36.7949 57.4151H74.6475M55.7212 44.3086V72.698" stroke="currentColor" stroke-width="5.57143" />
    </g>
    <defs>
      <clipPath id="clip0_48352_215805">
        <rect x="0.515625" y="0.40625" width="100" height="100" rx="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
